import { createFileRoute } from "@tanstack/react-router";
import { EtimsActivationPage } from "@/features/etims/pages/etims-activation";

export const Route = createFileRoute("/(app)/dashboard/etims-activation")({
  component: () => <EtimsActivationPage />,
});
